import cx from "classnames";
import React from "react";
import styles from "./SelectableList.scss";

export const SelectableList = ({ children }) => <div className={styles.SelectableList}>{children}</div>;

export const ListItem = ({ selected, children, onClick }) => (
  <div className={cx(styles.ListItem, { [styles.Selected]: selected })} onClick={onClick}>
    <div className={cx(styles.Checkbox, selected && styles.checked)} />
    {children}
  </div>
);
